import { links } from "data";
import { AccordionContainer } from "./accordion-container";
import styles from "./accordions.module.scss";
import { AccordionLink } from "./accordion-link";

export const ABOUT_ACCORDION_KEY = "ABOUT_ACCORDION_KEY";

export const AboutAccordion = () => {
  return (
    <AccordionContainer accordionKey={ABOUT_ACCORDION_KEY}>
      <div className="flex flex-column">
        <span className={styles.subtitle}>About CitySprint</span>
        <AccordionLink href={links.NATIONAL_COVERAGE}>
          National coverage
        </AccordionLink>
        <AccordionLink href={links.OUR_CUSTOMERS}>Our customers</AccordionLink>
        <AccordionLink href={links.ABOUT_US}>Who we are</AccordionLink>
        <AccordionLink href={links.OUR_PEOPLE}>Our people</AccordionLink>
        <AccordionLink href={links.OUR_FLEET}>Our fleet</AccordionLink>
        <span className={styles.subtitle}>Helping you grow</span>
        <AccordionLink href={links.CASE_STUDIES}>Case studies</AccordionLink>
        <AccordionLink href={links.TESTIMONIALS}>Testimonials</AccordionLink>
        <AccordionLink href={links.AWARDS}>Awards</AccordionLink>
        <AccordionLink href={links.TECHNOLOGY}>Technology</AccordionLink>
        <AccordionLink href={links.SELL_YOUR_BUSINESS}>
          Selling your business?
        </AccordionLink>
        <span className={styles.subtitle}>Building a better future</span>
        <AccordionLink href={links.CSR_FOCUS}>CSR Focus</AccordionLink>
        <AccordionLink href={links.SUSTAINABLE_DELIVERY}>
          Sustainable delivery
        </AccordionLink>
        <AccordionLink href={links.SUPPORTING_LOCAL_COMMUNITIES}>
          Supporting local communities
        </AccordionLink>
        <AccordionLink href={links.EMPOWERING_OUR_PEOPLE}>
          Empowering our people
        </AccordionLink>
        <AccordionLink href={links.BACKING_BUSINESS}>
          Backing business
        </AccordionLink>
        <span className={styles.subtitle}>Work with us</span>
        <AccordionLink href={links.CAREERS}>Careers</AccordionLink>
        <AccordionLink href={links.BECOME_A_COURIER}>
          Become a courier
        </AccordionLink>
      </div>
    </AccordionContainer>
  );
};
